import { Box } from "@cjdev-internal/visual-stack-x/Box";
import { MDIcon } from "@cjdev-internal/visual-stack-x/components/MDIcon";
import React from "react";

export const WebsiteIcon = ({ ...restProps }) => (
  <Box direction="row" align="start" style={{ color: "#49C5B1" }}>
    <MDIcon icon="web" {...restProps} />
  </Box>
);
